import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faInstagram, faBehance, faPinterest } from "@fortawesome/free-brands-svg-icons";

const footerLinks = [
  { label: "Preços", href: "/planos" },
  { label: "Sobre Nós", href: "/sobre" },
  { label: "Termos de serviços", href: "/termos" },
  { label: "Política de privacidade", href: "/privacidade" }
];

const socialLinks = [
  { label: "WhatsApp", href: "https://wa.me/5511914666383", icon: faWhatsapp },
  { label: "Instagram", href: "https://www.instagram.com/artesturbo_", icon: faInstagram },
  { label: "Behance", href: "#", icon: faBehance },
  { label: "Pinterest", href: "#", icon: faPinterest }
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-brand-dark py-12 text-sm text-slate-300">
      <div className="absolute inset-x-0 -top-1 h-1 bg-brand-gradient shadow-[0_0_20px_rgba(124,58,237,0.5)]" aria-hidden />
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <Image
              src="/images/logo/logo.png"
              alt="Artes Turbo"
              width={200}
              height={30}
              className="h-7 w-auto"
            />
            <p className="mt-3 max-w-sm text-sm text-slate-400">
              Recursos premium para profissionais criativos: coleções curadas, vídeos institucionais e ferramentas exclusivas.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-secondary/80">Navegação</h4>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-2 text-slate-400 transition-colors hover:text-white"
                  >
                    <FontAwesomeIcon icon={faArrowRight} className="h-3.5 w-3.5 text-brand-secondary/70" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-secondary/80">Contato</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {/* <li className="flex items-center gap-3">
                <FontAwesomeIcon icon={faEnvelope} className="h-4 w-4 text-brand-secondary" />
                <a href="mailto:contato@criedesign.com.br" className="hover:text-white">contato@criedesign.com.br</a>
              </li> */}
              <li className="flex items-center gap-3">
                <FontAwesomeIcon icon={faWhatsapp} className="h-4 w-4 text-brand-secondary" />
                <a
                  href="https://api.whatsapp.com/send/?phone=5511914666383&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-secondary/80">Redes Sociais</h4>
            <div className="mt-4 flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-400 transition-all hover:border-brand-secondary/50 hover:bg-brand-secondary/10 hover:text-brand-secondary"
                  aria-label={social.label}
                >
                  <FontAwesomeIcon icon={social.icon} className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-white/5 pt-6 sm:flex-row sm:items-center sm:justify-center">
          <p className="text-xs text-slate-500 text-center">Copyright© 2023-2025 ArtesTurbo Ltda. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
